<template>
  <modal :show="showModal" modal-classes="modal-secondary" size="lg">
    <form class="" @submit.prevent="">
      <!-- <base-input
        :label="`${$t('SALES_ORDERS.ITEM_TYPE')}`"
        v-if="!salesOrderItem.id"
      >
        <el-select
          name="Type"
          v-model="salesOrderItemModel.salesOrderable.type"
          prepend-icon="fas fa-calendar"
          @change="changeSalesOrderableType"
        >
          <el-option :value="null" :label="$t('COMMON.NONE')" />
          <el-option
            v-if="salesOrder.organization"
            value="products"
            :label="$t('COMMON.PRODUCT')"
          />
          <el-option
            v-if="
              !$currentUserIsLevelOrganization() && !salesOrder.organization
            "
            value="packages"
            :label="$t('COMMON.PACKAGE')"
          />
        </el-select>
      </base-input>
      <validation-error :errors="apiValidationErrors.salesOrderable" /> -->

      <div>
        <base-input
          v-if="salesOrderItemModel.salesOrderable.type.includes('products')"
          :label="`${$t(`COMMON.PRODUCT`)} (*)`"
        >
          <product-selector
            :filterOrganization="salesOrder.organization.id"
            :productObject="salesOrderItemModel.salesOrderable"
            :allowNone="false"
            :showAll="false"
            :filterWarehouse="
              salesOrder.sourceWarehouse ? salesOrder.sourceWarehouse.id : null
            "
            @productChanged="productChanged"
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.salesOrderable" />
      </div>

      <base-input
        :label="`${$t('COMMON.CODE')} (*)`"
        :placeholder="$t('COMMON.CODE')"
        v-model="salesOrderItemModel.code"
        input-classes="form-control-alternative"
        v-if="!salesOrderItemModel.salesOrderable.type"
      >
      </base-input>
      <validation-error
        v-if="!salesOrderItemModel.salesOrderable.type"
        :errors="apiValidationErrors.code"
      />

      <base-input
        :label="$t('COMMON.EXCERPT')"
        :placeholder="$t('COMMON.EXCERPT')"
        input-classes="form-control-alternative"
      >
        <html-editor
          v-model="salesOrderItemModel.excerpt"
          @change="onFormChanged()"
        >
        </html-editor>
      </base-input>
      <validation-error :errors="apiValidationErrors.excerpt" />

      <base-input
        :label="`${$t('COMMON.UNIT_PRICE')} (*)`"
        :placeholder="$t('COMMON.UNIT_PRICE')"
        v-model="salesOrderItemModel.unit_price"
        type="number"
        step="0.0001"
        input-classes="form-control-alternative"
      >
      </base-input>
      <validation-error :errors="apiValidationErrors.unit_price" />

      <base-input
        :label="`${$t('COMMON.QUANTITY')} (*)`"
        :placeholder="$t('COMMON.QUANTITY')"
        v-model="salesOrderItemModel.quantity"
        type="number"
        step="1"
        input-classes="form-control-alternative"
      >
      </base-input>
      <validation-error :errors="apiValidationErrors.quantity" />

      <taxes-selector
        :label="$t('COMMON.TAXES')"
        :taxes="salesOrderItemModel.taxes"
        @taxesChanged="(taxes) => (salesOrderItemModel.taxes = taxes)"
      />
      <validation-error :errors="apiValidationErrors.taxes" />

      <base-input
        :label="$t('COMMON.DISCOUNT_PERCENT')"
        :placeholder="$t('COMMON.DISCOUNT_PERCENT')"
        v-model="salesOrderItemModel.discount"
        type="number"
        step="0.0001"
        input-classes="form-control-alternative"
      >
      </base-input>
      <validation-error :errors="apiValidationErrors.discount" />
    </form>

    <template slot="footer">
      <button
        v-if="!salesOrderItemModel.id"
        type="submit"
        class="btn btn-primary"
        @click="submitSalesOrderItemForm"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("SALES_ORDERS.ADD_SALES_ORDER_ITEM") }}
      </button>

      <base-button
        v-if="salesOrderItemModel.id"
        native-type="submit"
        type="primary"
        class="new-sales-order-item--add"
        @click="submitSalesOrderItemForm"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("SALES_ORDERS.UPDATE_SALES_ORDER_ITEM") }}
      </base-button>

      <base-button
        v-if="salesOrderItemModel.id"
        type="danger"
        @click="deleteSalesOrderItem(salesOrderItemModel.id)"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("SALES_ORDERS.DELETE_SALES_ORDER_ITEM") }}
      </base-button>

      <button
        type="button"
        class="btn btn-link ml-auto"
        @click="closeSalesOrderItemModal"
        :disabled="loading"
      >
        {{ $t("COMMON.CLOSE") }}
      </button>
    </template>
  </modal>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import TaxesSelector from "@/components/TaxesSelector.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import ValidationError from "@/components/ValidationError.vue";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import defaultSalesOrderItem from "../defaultSalesOrderItem";

export default {
  name: "sales-order-view-details-sales-order-item-form",

  components: {
    HtmlEditor,
    ValidationError,
    TaxesSelector,
    ProductSelector,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["salesOrder", "salesOrderItem", "showModal", "loading", "formErrors"],

  data() {
    return {
      salesOrderItemModel: cloneDeep(defaultSalesOrderItem),
    };
  },

  computed: {},

  methods: {
    closeSalesOrderItemModal() {
      this.$emit("onCloseSalesOrderItemModal", true);
    },

    submitSalesOrderItemForm() {
      const salesOrderItemData = cloneDeep(this.salesOrderItemModel);
      salesOrderItemData.unit_price = parseFloat(salesOrderItemData.unit_price);
      salesOrderItemData.quantity = parseInt(salesOrderItemData.quantity, 10);
      salesOrderItemData.discount = parseFloat(salesOrderItemData.discount);
      if (!salesOrderItemData.salesOrderable.id) {
        salesOrderItemData.salesOrderable = null;
      }

      this.$emit("onSubmitSalesOrderItemForm", salesOrderItemData);
    },

    deleteSalesOrderItem(salesOrderItemId) {
      this.$emit("onDeleteSalesOrderItem", salesOrderItemId);
    },

    productChanged(productId, product) {
      if (product.warehouseProduct) {
        this.salesOrderItemModel.salesOrderable = {
          type: "warehouse-products",
          id: product.warehouseProduct.id.toString(),
        };
        this.salesOrderItemModel.unit_price =
          product.warehouseProduct.selling_price;
        this.salesOrderItemModel.code =
          product.warehouseProduct.sku || product.sku || product.code;
        this.salesOrderItemModel.excerpt = product.denomination;
        this.salesOrderItemModel.taxes = product.warehouseProduct.taxes;
      } else {
        this.salesOrderItemModel.salesOrderable.id = productId;
        this.salesOrderItemModel.unit_price = product.price;
        this.salesOrderItemModel.code = product.code;
        this.salesOrderItemModel.excerpt = product.denomination;
        this.salesOrderItemModel.taxes = product.taxes;
      }
      this.salesOrderItemModel.salesOrderable.product_id = product.id;
    },
  },

  mounted() {},

  watch: {
    salesOrderItem(salesOrderItem) {
      if (salesOrderItem) {
        this.salesOrderItemModel = cloneDeep(salesOrderItem);
      }
      this.resetApiValidation();
    },

    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
  },
};
</script>
